export const LoadPolicyConstants = {
  BACK_TO_DASHBOARD: 'BACK_TO_DASHBOARD',
  TRY_AGAIN: 'TRY_AGAIN',
  SESSION_SECONDS: 1800,
  AB_TEST_SECONDS: 10,
};
